import {} from "@mui/material";
import type React from "react";
import type { AdminDeliveryProposalDetailPageProps } from "../model";
import { DeliveryProposalDetailInProgress } from "./in-progress";
import { DeliveryProposalDetailPreview } from "./preview";

export const AdminDeliveryProposalDetailPageUi: React.FC<
  AdminDeliveryProposalDetailPageProps
> = (props) => {
  if (props.previewValues) {
    return <DeliveryProposalDetailPreview {...props} />;
  }
  return <DeliveryProposalDetailInProgress {...props} />;
};
